import React, { useState } from 'react';
import { useGetQty1Query } from '../store/apiSlice';
import JobSearchContainer from '../components/JobSearchContainer'; // Import the new container
import { BsHandbag } from 'react-icons/bs';

const SearchResults2 = ({ q, filters }) => {
  // --- STATE MANAGEMENT ---
  // This component now only manages state for its *unique* UI controls.
  const [viewCurrent, setViewCurrent] = useState(true);
  const [dateRange, setDateRange] = useState({ startDate: '', endDate: '' });

  // --- DATA FETCHING ---
  // It still fetches the unique quantity data.
  const { data: qty, isLoading: isLoadingQty } = useGetQty1Query(q);

  // --- DERIVED STATE ---
  // We build the parameters for the JobSearchContainer based on the state of this component.
  // This object will be passed as a prop.
  const searchParamsForContainer = {
    ...q, // The base query object from props (e.g., {q: 'search term'})
    expired: viewCurrent ? "0" : "1",
    startDate: dateRange.startDate,
    endDate: dateRange.endDate,
    // Use initial filters from props, but let JobSearchContainer manage its state thereafter.
    // This allows for deep-linking with pre-selected filters.
    selectedFilters: filters || [],
  };

  if (isLoadingQty) {
    // A simpler loading state is fine, as JobSearchContainer has its own internal loading state.
    return (
      <div className="p-6 text-center text-gray-500">
        Loading job counts...
      </div>
    );
  }

  return (
    <div className="w-full">
      {/* ==================================================================== */}
      {/*  This is the section of UNIQUE controls for this specific page.     */}
      {/* ==================================================================== */}
      <div className="p-4 bg-white shadow-md rounded-lg mb-6 border border-gray-200">
        <div className="flex items-center gap-4 mb-4">
          <BsHandbag className="text-blue-600" />
          <h3 className="font-bold text-lg text-gray-800">Job Status</h3>
        </div>

        {/* Current/Expired Toggle with Counts */}
        <div className="flex flex-wrap items-center gap-x-4 gap-y-2">
          {qty?.currentQty !== undefined && (
            <button
              onClick={() => setViewCurrent(true)}
              className={`px-3 py-1 text-sm font-semibold rounded-full transition-colors ${viewCurrent
                  ? 'bg-blue-600 text-white shadow'
                  : 'bg-gray-200 text-gray-700 hover:bg-gray-300'
                }`}
            >
              Current ({qty.currentQty} | {qty.currentSalesLeadsQty} leads)
            </button>
          )}

          {qty?.expiredQty !== undefined && (
            <button
              onClick={() => setViewCurrent(false)}
              className={`px-3 py-1 text-sm font-semibold rounded-full transition-colors ${!viewCurrent
                  ? 'bg-blue-600 text-white shadow'
                  : 'bg-gray-200 text-gray-700 hover:bg-gray-300'
                }`}
            >
              Expired ({qty.expiredQty} | {qty.expiredSalesLeadsQty} leads)
            </button>
          )}
        </div>

        {/* Date Range Filter */}
        {/* <div className="mt-4 pt-4 border-t border-gray-200">
          <label className="block text-sm font-medium text-gray-700 mb-1">Filter by Expiration Date Range</label>
          <div className="flex items-center gap-2">
            <input
              type="date"
              name="startDate"
              value={dateRange.startDate}
              onChange={(e) => setDateRange(prev => ({ ...prev, startDate: e.target.value }))}
              className="block w-full text-sm border-gray-300 rounded-md shadow-sm"
            />
            <span className="text-gray-500">to</span>
            <input
              type="date"
              name="endDate"
              value={dateRange.endDate}
              onChange={(e) => setDateRange(prev => ({ ...prev, endDate: e.target.value }))}
              className="block w-full text-sm border-gray-300 rounded-md shadow-sm"
            />
          </div>
        </div> */}
      </div>

      {/* ==================================================================== */}
      {/*  Here we render our reusable, self-contained search component.     */}
      {/* ==================================================================== */}
      <JobSearchContainer
        // The key is a crucial part of this pattern. When the parameters from
        // this parent component change (e.g., toggling expired), we change
        // the key. This tells React to create a *new instance* of
        // JobSearchContainer, ensuring it initializes with our new props.
        key={JSON.stringify(searchParamsForContainer)}
        title={viewCurrent ? "Current Job Results" : "Expired Job Results"}
        initialSearchParams={searchParamsForContainer}
      />
    </div>
  );
};

export default SearchResults2;